module.exports = __webpack_public_path__ + "img/survey.2bd52c28.svg";